import { useQuery } from '@tanstack/react-query';

import { api } from '@api';

export const useNoticesForRealEstate = (
  realEstateId: string | undefined,
  options = {
    disabled: false,
  }
) => {
  const isEnabled = !options.disabled && !!realEstateId;

  const queryResult = useQuery(
    ['notices-for-real-estate', realEstateId],
    async () =>
      (await api.notices.fetchNoticesForRealEstate(realEstateId!)).data,
    { enabled: isEnabled }
  );

  return { ...queryResult, isLoading: isEnabled && queryResult.isLoading };
};
